



import Vue from "vue";
import { computed } from "@vue/composition-api";

export default Vue.extend({
  props: ["level"],
  setup(props) {
    const icon = computed(() => {
      const val = props.level;
      switch (val) {
        case 1:
        case 0.2:
        case "l":
        case "Low":
          return "Sensitivity_L"; //"L"; //"Sensitivity_L";
        case 2:
        case "M":
        case 0.5:
        case "Medium":
          return "Sensitivity_M"; //"M"; //"Sensitivity_M";
        case 3:
        case "h":
        case 0.85:
        case "High":
          return "Sensitivity_H"; //"H"; //;
        case 0:
        case "n":
        case "None":
        default:
          return "Sensitivity_N"; //"N"; //
      }
    });
    return {
      icon,
    };
  },
});
